import { render, staticRenderFns } from "./DataTableBasicSync.vue?vue&type=template&id=921efef8"
import script from "./DataTableBasicSync.vue?vue&type=script&lang=js"
export * from "./DataTableBasicSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports